<template>
  <div>
    <main-navbar type="9"></main-navbar>
    <div class="container">
      <div>
        <main-menu type="0"></main-menu>
      </div>
      <div class="row">
        <!--        <div class="col-sm-3 d-none d-sm-block menu-group">-->
        <left-bar></left-bar>
        <div class="col-sm-9 col-12 bg-group">
          <div class="d-flex">
            <div class="mr-auto p-2">
              <div class="row">
                <span style="font-size:1.2em" class="float-left ml-2">让帖子，被看见</span>
                <div class="New-titleTip float-right"><a href="https://groups.wenxuecity.com/help/?id=11" style="color: rgb(103, 194, 58);">如何设置推广置顶贴</a>
                </div>
              </div></div>
            <el-button style="height: 37px" class="p-2 d-flex justify-content-center align-middle" @click="menuId=1" :style="menuId===1?{color:'#44753d', fill: '#44753d', background: '#ffffff',border:'1px solid rgb(96 137 92)'}:''"><i style="font-size:18px" class="el-icon-chat-line-round text-muted s mr-1"></i>最新评论</el-button>
            <el-button style="height: 37px" class="p-2 d-flex justify-content-center align-middle" @click="menuId=0" :style="menuId===0?{color:'#44753d', fill: '#44753d', background: '#ffffff',border:'1px solid rgb(96 137 92)'}:''"><i style="font-size:18px" class="el-icon-news text-muted s mr-1"></i>最新推广</el-button>
          </div>
<!--          <main-category-bar-->
<!--              v-bind:activeId="currentTagId"-->
<!--              v-on:get-tagid="gotTagId"-->
<!--              v-bind:data="maincategory">-->
<!--          </main-category-bar>-->
          <div
              v-infinite-scroll="loadArticle"
              infinite-scroll-disabled="disabled"
              infinite-scroll-distance="50">
            <div  v-if="menuId===0">
            <article-list-item
                v-for="item in articlelistsnew"
                v-bind:key="item.articleID"
                v-bind:data="item"
                type="0">
            </article-list-item>
            </div>
            <div  v-if="menuId===1">
            <article-list-item
                v-for="item in articlelists"
                v-bind:key="item.articleID"
                v-bind:data="item"
                type="0">
            </article-list-item>
           </div>
          </div>
          <div class="text-center py-5" v-if="loading.article"><!-- loader -->
            <i class="now-ui-icons loader_refresh spin"></i>
          </div>
          <p class="text-center py-4" v-if="noMore">没有更多了</p>
        </div>
    </div>
  </div>
</div>
</template>
<script>
import MainNavbar from '@/layout/MainNavbar.vue';
import icons from "@/components/Icons/Icons";
import MainMenu from '../pages/components/Main/MainMenu';
// import MainCategoryBar from '@/module/group/pages/components/Main/MainCategoryBar';
import LeftBar from '@/module/group/user/group/LeftBar.vue';
import group from '@/module/group/group.service';
import ArticleListItem from '@/module/group/pages/components/Main/ArticleListItem';

export default {
  name: 'index-hot',
  bodyClass: 'index-page',
  components: {
    MainNavbar,
    MainMenu,
    // MainCategoryBar,
    ArticleListItem,
    LeftBar
  },
  created () {
    this.menuId = Number(0);
    group.group_tag().then(res=>{
      if(res.status){
        this.maincategory=res.data;
      }
    }).catch(err=>{
      console.log(err);
    });

    this.loadArticle()

  },
  methods:{
    gotTagId(id){
      this.currentTagId = id;
      this.LastID = 0;
      this.articlelists = [];
      this.articlelistsnew = [];
      this.loadArticle();
    },
    loadArticle(){
      this.loading.article=true;
      // if(this.menuId==0){
      group.hot_article(this.currentTagId,this.LastID).then(res=>{
        if(res.status){
          let arr = res.data;
          this.noMore = arr.length<20 ? true : false;
          this.LastID = arr.length===20 ? arr[arr.length-1].postInfo_postID.comment_date : this.LastID;
          this.articlelists = this.articlelists.concat(arr) ;
          this.loading.article=false;
        }
      })
      // };
      // if(this.menuId==0){
      group.new_article(this.currentTagId,this.LastID).then(res=>{
        if(res.status){
          let arr = res.data;
          this.noMore = arr.length<20 ? true : false;
          this.LastID = arr.length===20 ? arr[arr.length-1].postInfo_postID.comment_date : this.LastID;
          this.articlelistsnew = this.articlelistsnew.concat(arr) ;
          this.loading.article=false;
        }
      })
      // }
    },
  },
  data() {
    return {
      currentTagId:0,
      noMore:false,
      LastID:0,
      loading:{article:true},
      maincategory:[
        // {id:'0',name:'投资理财',visible:1},
      ],
      res_bloggerList:[],
      bloggerList : [],
      articlelists: [],
      articlelistsnew: [],
      icons:icons,
      menuId:0,
    };
  },
  computed:{
    disabled () {
      return this.loading.article || this.noMore
    }
  }
};
</script>
<style></style>
